module.exports = __webpack_public_path__ + "static/media/payment-option-nagad.578fe874.svg";